
import Vue from 'vue'

export default Vue.extend({
   name: 'DebugComponent',
   computed: {
      visible(): boolean {
         return process.env.NODE_ENV === 'Development'
      },
   },
})
